<template>
    <div class="home_bcg">
        <header>
            <img src="../../assets/mobhome.png" alt="" style="height:3.5rem">
        </header>
        <nav >
            <el-carousel id="ac" height="4.3rem" ref="carousel"  :autoplay="false"  arrow="never">
                <el-carousel-item v-for="(item,k) in dataList" :key="k">
                    <ul class="clearfix">
                        <li v-for="(v,key) in item " :key="key" @click="goPath(v.path)">
                            <div class="icon_box"><i :class="v.class" :style="{'background':v.background}" ></i></div>
                            <div>{{v.name}}</div>
                        </li>
                    </ul>
                </el-carousel-item>
            </el-carousel>

        </nav>
        <article>
            <div class="market_news" ref="nav"><p style="font-weight: bold;">市场快讯</p></div>
            <footer >
                <ul
                        v-infinite-scroll="loadMore"
                        :style="{'height':curHeight,'width':'100%','margin':'0px','padding':' 0px','overflow': 'auto'}"
                        infinite-scroll-disabled="loading"
                        infinite-scroll-distance="3">
                    <li v-for="item in list" style="border-bottom:1px solid #e4e4e44f;padding:3px 0px">
                        <div style="display: inline-block;width:75%;padding:0px 0px 0px 10px" class="footer_text">咨询咨询咨询咨询咨询咨询咨询咨询咨询咨询咨询咨询{{ item }}</div>
                        <div style="display: inline-block;width:22%;text-align: right;padding:0px 10px 0px 10px ">查看更多</div>
                    </li>
                    <li style="text-align: center"><i v-if="loading" class="fa fa-spinner fa-pulse fa-2x fa-fw"></i></li>
                </ul>
            </footer>
        </article>

    </div>
</template>
<script>
    export default {
        name:'homePage',
        data(){
            return{
                dataList:[],
                list:[1,2,3],
                loading:false,
                curHeight:'0px',
                fullHeight:'',
                styleList:['#2553d6','darkcyan','darkslateblue','maroon','#f4807d','#60e0bf','#fbd503','#ff5353','#22bfa2','#feb453','#86cf75','#29c1e6','#c196eb','#e0b302','darkturquoise','#5a5957','#d04a16','#d04a16'],
                menuList:[{name:'我的保单',class:'iconfont icon-baodanyangben',background:'#2553d6',path:'/mobile/myPolicy'}
                    ,{name:'我的客户',class:'iconfont icon-kehu',background: 'darkcyan'},{name:'預約申請',class:'iconfont icon-shenqing11',background: 'darkslateblue',path:'/mobile/mobOverseaApp'}
                    ,{name:'市場資料',class:'iconfont icon-chanpinguanli1',background: 'maroon'},{name:'法規資料',class:'iconfont icon-falvfagui',background:'#f4807d'}
                    ,{name:'產品資料',class:'iconfont icon-chanpingongchang',background:'#60e0bf'},{name:'圖書館',class:'iconfont icon-tushuguan',background:'#fbd503'},
                    {name:'E-card',class:'iconfont icon-shenfenzhenghaoma',background:'#ff5353'},{name:'子賬號',class:'iconfont icon-zizhanghaoguanli',background:'#22bfa2'},
                    {name:'個人咨詢費率',class:'iconfont icon-feishuaiguanli',background:'#feb453'}, {name:'搜索建議書',class:'iconfont icon-icon-test',background:'#86cf75'},
                    {name:'個人咨詢費明細表',class:'iconfont icon-zixun2',background:'#29c1e6'},{name:'認證費申報',class:'iconfont icon-iconfontzhizuobiaozhun0279',background:'#c196eb'},
                    {name:'產品培訓資料',class:'iconfont icon-quyujishushichang',background:'#e0b302'},{name:'重要通告資料',class:'iconfont icon-xinbaniconshangchuan-',background:'darkturquoise'}
                    , {name:'員工通告',class:'iconfont icon-iconset0407',background:'#5a5957'},{name:'新冠病毒快訊2',class:'iconfont icon-xinxi',background:'#d04a16'},{name:'新冠病毒快訊2',class:'iconfont icon-xinxi',background:'#d04a16'}
                ]
            }
        },
        watch: {
            fullHeight (val) {
                if(!this.timer) {
                    this.fullHeight = val
                    this.timer = true
                    let that = this
                    var curHeight =document.documentElement.clientHeight-this.$refs.nav.getBoundingClientRect().bottom
                    this.curHeight=curHeight+'px'
                    setTimeout(function (){   that.timer = false   },400)   }  } },
        methods:{
            goPath(path){
                this.$router.push({path})
            },
            getList(){
                if(this.menuList.length>0){
                    let arr2=[]
                    for(let a=0;a<this.menuList.length;a++){
                        if(this.menuList.length>=4){
                            arr2.push(this.menuList[a])
                            if((a+1)%6==0){
                                this.dataList.push(arr2)
                                arr2=[]
                            }
                            if((a+1)%6>0){
                                if(a==this.menuList.length-1){
                                    this.dataList.push(arr2)
                                }
                            }
                        }
                        if(this.menuList.length<6){
                            arr2.push(this.menuList[a])
                            if(a==this.menuList.length-1){
                                this.dataList.push(arr2)
                            }
                        }
                    }

                }


            },
            changeCss(){
                let a="";
                for(let i =0;i<document.styleSheets.length;i++){
                    let rules;
                    if(document.styleSheets[i].cssRules){
                        rules = document.styleSheets[i].cssRules;
                    }else{
                        rules = document.styleSheets[i].rules;
                    }
                    for(var j=0;j<rules.length;j++){
                        if(rules[j].selectorText == '.el-carousel__button'){
                            a= rules[j].style;
                            break;
                        }
                    }
                }
                a.height = "2px"
                a.background='#fb7b0e'
            },
            slideBanner(){
                // 选中item的盒子
                var box = document.querySelector('.el-carousel__container');
                //手指起点X坐标
                var startPoint = 0;
                //手指滑动重点X坐标
                var stopPoint = 0;

                //重置坐标
                var resetPoint =  function(){
                    startPoint = 0;
                    stopPoint = 0;
                }

                //手指按下
                box.addEventListener("touchstart",function(e){
                    //手指按下的时候停止自动轮播
                    //手指点击位置的X坐标
                    startPoint = e.changedTouches[0].pageX;
                });
                //手指滑动
                box.addEventListener("touchmove",function(e){
                    //手指滑动后终点位置X的坐标
                    stopPoint = e.changedTouches[0].pageX;
                });
                let that=this
                //当手指抬起的时候，判断图片滚动离左右的距离
                box.addEventListener("touchend",function(e){
                    if(stopPoint == 0 || startPoint - stopPoint == 0){
                        resetPoint();
                        return;
                    }

                    if(startPoint - stopPoint > 0){
                        resetPoint();
                        that.$refs.carousel.next();
                        return;
                    }
                    if(startPoint - stopPoint < 0){
                        resetPoint();
                        that.$refs.carousel.prev();
                        return;
                    }
                });
            },
            loadMore() {
                this.loading = true;
                setTimeout(() => {
                    let last = this.list[this.list.length - 1];
                    for (let i = 1; i <= 10; i++) {
                        this.list.push(last + i);
                    }
                    this.loading = false;
                }, 2500);
            }
        },
        mounted() {
            this.getList()
            const that = this
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight
                    that.fullHeight = window.fullHeight
                })() }
            var curHeight =document.documentElement.clientHeight-this.$refs.nav.getBoundingClientRect().bottom
            this.curHeight=curHeight+'px'
            this.changeCss()
            this.slideBanner()
        }
    }
</script>
<style scoped>
    ul li div:nth-child(1){
        padding: 6px 0px;
    }
    ul li div:nth-child(2){
        padding: 5px 0px;
        font-weight: bold;
        font-size:0.25rem;
    }
    .iconfont{
        font-size: 0.6rem;
        color:#FFFFFF;
        padding: 12px;
        border-radius: 50%;
    }
    #ac  .el-carousel__button {
        display: block;
        opacity: .48;
        width: 21px!important;
        height: 5px;
        background-color: #fb7b0e!important;
        border: none;
        outline: 0;
        padding: 0;
        margin: 0;
        cursor: pointer;
        -webkit-transition: .3s;
        transition: .3s;}
    .home_bcg{
        left: 0px;
        right:0px;
        position: fixed;
        bottom: 0px;
        top:0px;
        background: #FFFFFF;

    }
    .clearfix:after{/*伪元素是行内元素 正常浏览器清除浮动方法*/
        content: "";
        display: block;
        height: 0;
        clear:both;
        visibility: hidden;
    }
    .clearfix{
        *zoom: 1;/*ie6清除浮动的方式 *号只有IE6-IE7执行，其他浏览器不执行*/
        padding:0rem;
        margin:0rem;
    }
    nav{
        background: #FFFFFF;
        padding:10px 0px 0px 0px;
    }
    nav ul li{
        float: left;
        width:33%;
        text-align: center;
        padding:0.2rem 0rem;
    }
    .el-carousel__button{
        color: #94c93d!important;
    }
    header{
        background: rgb(69 131 243);
        text-align: center;
        padding: 0.5rem;
        border-bottom-left-radius: 22%;
        border-bottom-right-radius: 22%;
    }
    footer{
        /*background: #e2e2e2;*/
        /* height:2rem;*/
    }
    .market_news{
        font-size:0.3rem;
        background:#f7f7f7;
        padding:0px 10px;
    }
    .market_news p{
        padding:0.1rem 0rem;
        border-bottom:2px solid #cd9718;
        width:20%;
    }
    .footer_text{
        display: inline-block;
        width:75%;
        padding:0px 0px 0px 10px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        word-break: break-all;

    }
</style>



// WEBPACK FOOTER //
// src/views/mobile/homePage.vue